import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import './SignUp.css';

const images = [
  '/images/SignIn.png',
  '/images/SignIn.png',
  '/images/SignIn.png',
  '/images/SignIn.png',
  '/images/SignIn.png',
  // All images will now be SignIn.png
];

const countries = [
  { name: 'United States', code: '+1' },
  { name: 'Canada', code: '+1' },
  { name: 'United Kingdom', code: '+44' },
  { name: 'Australia', code: '+61' },
  { name: 'India', code: '+91' },
  { name: 'Germany', code: '+49' },
  { name: 'France', code: '+33' },
  { name: 'Japan', code: '+81' },
  { name: 'China', code: '+86' },
  { name: 'Brazil', code: '+55' },
  { name: 'Mexico', code: '+52' },
  { name: 'South Africa', code: '+27' },
  { name: 'Argentina', code: '+54' },
  { name: 'Egypt', code: '+20' },
  { name: 'Nigeria', code: '+234' },
  { name: 'Italy', code: '+39' },
  { name: 'Spain', code: '+34' },
  { name: 'Russia', code: '+7' },
  { name: 'South Korea', code: '+82' },
  { name: 'Indonesia', code: '+62' },
  { name: 'Pakistan', code: '+92' },
  { name: 'Bangladesh', code: '+880' },
  { name: 'Philippines', code: '+63' },
  { name: 'Vietnam', code: '+84' },
  { name: 'Turkey', code: '+90' },
  { name: 'Thailand', code: '+66' },
  { name: 'Colombia', code: '+57' },
  { name: 'Kenya', code: '+254' },
  { name: 'New Zealand', code: '+64' },
  { name: 'Sweden', code: '+46' },
  { name: 'Norway', code: '+47' },
  { name: 'Denmark', code: '+45' },
  { name: 'Finland', code: '+358' },
  { name: 'Netherlands', code: '+31' },
  { name: 'Belgium', code: '+32' },
  { name: 'Switzerland', code: '+41' },
  { name: 'Austria', code: '+43' },
  { name: 'Portugal', code: '+351' },
  { name: 'Greece', code: '+30' },
  { name: 'Ireland', code: '+353' },
  { name: 'Poland', code: '+48' },
  { name: 'Ukraine', code: '+380' },
  { name: 'Egypt', code: '+20' },
  { name: 'Israel', code: '+972' },
  { name: 'Saudi Arabia', code: '+966' },
  { name: 'United Arab Emirates', code: '+971' },
  { name: 'Singapore', code: '+65' },
  { name: 'Malaysia', code: '+60' },
  { name: 'Hong Kong', code: '+852' },
  { name: 'Chile', code: '+56' },
  { name: 'Peru', code: '+51' },
  { name: 'Venezuela', code: '+58' },
  { name: 'Argentina', code: '+54' },
  { name: 'Dominican Republic', code: '+1-809' },
  { name: 'Cuba', code: '+53' },
  { name: 'Puerto Rico', code: '+1-787' },
  { name: 'Jamaica', code: '+1-876' },
  { name: 'Haiti', code: '+509' },
  { name: 'Guatemala', code: '+502' },
  { name: 'Honduras', code: '+504' },
  { name: 'El Salvador', code: '+503' },
  { name: 'Nicaragua', code: '+505' },
  { name: 'Costa Rica', code: '+506' },
  { name: 'Panama', code: '+507' },
  { name: 'Trinidad and Tobago', code: '+1-868' },
  { name: 'Bahamas', code: '+1-242' },
  { name: 'Barbados', code: '+1-246' },
  { name: 'Belize', code: '+501' },
  { name: 'Guyana', code: '+592' },
  { name: 'Suriname', code: '+597' },
  { name: 'Ecuador', code: '+593' },
  { name: 'Paraguay', code: '+595' },
  { name: 'Uruguay', code: '+598' },
  { name: 'Bolivia', code: '+591' },
  { name: 'Rwanda', code: '+250' },
  { name: 'Uganda', code: '+256' },
  { name: 'Tanzania', code: '+255' },
  { name: 'Ethiopia', code: '+251' },
  { name: 'Algeria', code: '+213' },
  { name: 'Morocco', code: '+212' },
  { name: 'Tunisia', code: '+216' },
  { name: 'Libya', code: '+218' },
  { name: 'Sudan', code: '+249' },
  { name: 'Chad', code: '+235' },
  { name: 'Niger', code: '+227' },
  { name: 'Mali', code: '+223' },
  { name: 'Burkina Faso', code: '+226' },
  { name: 'Senegal', code: '+221' },
  { name: 'Ghana', code: '+233' },
  { name: 'Ivory Coast', code: '+225' },
  { name: 'Cameroon', code: '+237' },
  { name: 'Congo (DRC)', code: '+243' },
  { name: 'Angola', code: '+244' },
  { name: 'Mozambique', code: '+258' },
  { name: 'Madagascar', code: '+261' },
  { name: 'Zambia', code: '+260' },
  { name: 'Zimbabwe', code: '+263' },
  { name: 'Botswana', code: '+267' },
  { name: 'Namibia', code: '+264' },
  { name: 'Zambia', code: '+260' },
  { name: 'Malawi', code: '+265' },
  { name: 'Mauritius', code: '+230' },
  { name: 'Seychelles', code: '+248' },
  { name: 'Comoros', code: '+269' },
  { name: 'Djibouti', code: '+253' },
  { name: 'Eritrea', code: '+291' },
  { name: 'Somalia', code: '+252' },
  { name: 'South Sudan', code: '+211' },
  { name: 'Central African Republic', code: '+236' },
  { name: 'Gabon', code: '+241' },
  { name: 'Equatorial Guinea', code: '+240' },
  { name: 'Republic of the Congo', code: '+242' },
  { name: 'Sao Tome and Principe', code: '+239' },
  { name: 'Cape Verde', code: '+238' },
  { name: 'Gambia', code: '+220' },
  { name: 'Guinea', code: '+224' },
  { name: 'Guinea-Bissau', code: '+245' },
  { name: 'Liberia', code: '+231' },
  { name: 'Sierra Leone', code: '+232' },
  { name: 'Togo', code: '+228' },
  { name: 'Benin', code: '+229' },
  { name: 'Burundi', code: '+257' },
  { name: 'Lesotho', code: '+266' },
  { name: 'Swaziland', code: '+268' },
  { name: 'Comoros', code: '+269' },
  { name: 'Maldives', code: '+960' },
  { name: 'Sri Lanka', code: '+94' },
  { name: 'Nepal', code: '+977' },
  { name: 'Bhutan', code: '+975' },
  { name: 'Myanmar', code: '+95' },
  { name: 'Cambodia', code: '+855' },
  { name: 'Laos', code: '+856' },
  { name: 'Mongolia', code: '+976' },
  { name: 'Afghanistan', code: '+93' },
  { name: 'Iran', code: '+98' },
  { name: 'Iraq', code: '+964' },
  { name: 'Syria', code: '+963' },
  { name: 'Lebanon', code: '+961' },
  { name: 'Jordan', code: '+962' },
  { name: 'Yemen', code: '+967' },
  { name: 'Oman', code: '+968' },
  { name: 'Kuwait', code: '+965' },
  { name: 'Qatar', code: '+974' },
  { name: 'Bahrain', code: '+973' },
  { name: 'Cyprus', code: '+357' },
  { name: 'Malta', code: '+356' },
  { name: 'Albania', code: '+355' },
  { name: 'Bosnia and Herzegovina', code: '+387' },
  { name: 'Croatia', code: '+385' },
  { name: 'North Macedonia', code: '+389' },
  { name: 'Serbia', code: '+381' },
  { name: 'Slovenia', code: '+386' },
  { name: 'Bulgaria', code: '+359' },
  { name: 'Romania', code: '+40' },
  { name: 'Hungary', code: '+36' },
  { name: 'Czech Republic', code: '+420' },
  { name: 'Slovakia', code: '+421' },
  { name: 'Latvia', code: '+371' },
  { name: 'Lithuania', code: '+370' },
  { name: 'Estonia', code: '+372' },
  { name: 'Iceland', code: '+354' },
  { name: 'Greenland', code: '+299' },
  { name: 'Faroe Islands', code: '+298' },
  { name: 'Aruba', code: '+297' },
  { name: 'Curacao', code: '+599' },
  { name: 'Sint Maarten', code: '+1-721' },
  { name: 'Bermuda', code: '+1-441' },
  { name: 'Cayman Islands', code: '+1-345' },
  { name: 'Gibraltar', code: '+350' },
  { name: 'Guam', code: '+1-671' },
  { name: 'Maldives', code: '+960' },
  { name: 'Fiji', code: '+679' },
  { name: 'New Caledonia', code: '+687' },
  { name: 'Papua New Guinea', code: '+675' },
  { name: 'Solomon Islands', code: '+677' },
  { name: 'Vanuatu', code: '+678' },
  { name: 'Samoa', code: '+685' },
  { name: 'Tonga', code: '+676' },
  { name: 'Nauru', code: '+674' },
  { name: 'Kiribati', code: '+686' },
  { name: 'Palau', code: '+680' },
  { name: 'Marshall Islands', code: '+692' },
  { name: 'Micronesia', code: '+691' },
  { name: 'Tuvalu', code: '+688' },
  { name: 'Wallis and Futuna', code: '+681' },
  { name: 'French Polynesia', code: '+689' },
  { name: 'Cook Islands', code: '+682' },
  { name: 'Niue', code: '+683' },
  { name: 'Tokelau', code: '+690' },
  { name: 'American Samoa', code: '+1-684' },
  { name: 'Northern Mariana Islands', code: '+1-670' },
  { name: 'Virgin Islands, British', code: '+1-284' },
  { name: 'Virgin Islands, U.S.', code: '+1-340' },
  { name: 'Saint Pierre and Miquelon', code: '+508' },
  { name: 'Anguilla', code: '+1-264' },
  { name: 'Antigua and Barbuda', code: '+1-268' },
  { name: 'Dominica', code: '+1-767' },
  { name: 'Grenada', code: '+1-473' },
  { name: 'Montserrat', code: '+1-664' },
  { name: 'Saint Kitts and Nevis', code: '+1-869' },
  { name: 'Saint Lucia', code: '+1-758' },
  { name: 'Saint Vincent and the Grenadines', code: '+1-784' },
  { name: 'Turks and Caicos Islands', code: '+1-649' },
  { name: 'Vanuatu', code: '+678' },
  { name: 'Aland Islands', code: '+358' },
  { name: 'Ascension Island', code: '+247' },
  { name: 'British Indian Ocean Territory', code: '+246' },
  { name: 'Cayman Islands', code: '+1-345' },
  { name: 'Christmas Island', code: '+61' },
  { name: 'Cocos (Keeling) Islands', code: '+61' },
  { name: 'Diego Garcia', code: '+246' },
  { name: 'Falkland Islands (Malvinas)', code: '+500' },
  { name: 'French Guiana', code: '+594' },
  { name: 'French Polynesia', code: '+689' },
  { name: 'French Southern Territories', code: '+262' },
  { name: 'Heard Island and McDonald Islands', code: '+672' },
  { name: 'Isle of Man', code: '+44' },
  { name: 'Jersey', code: '+44' },
  { name: 'Kosovo', code: '+383' },
  { name: 'Mayotte', code: '+262' },
  { name: 'Monaco', code: '+377' },
  { name: 'Montenegro', code: '+382' },
  { name: 'Norfolk Island', code: '+672' },
  { name: 'Pitcairn', code: '+870' },
  { name: 'Reunion', code: '+262' },
  { name: 'Saint Helena, Ascension and Tristan da Cunha', code: '+290' },
  { name: 'South Georgia and the South Sandwich Islands', code: '+500' },
  { name: 'Svalbard and Jan Mayen', code: '+47' },
  { name: 'Timor-Leste', code: '+670' },
  { name: 'Togo', code: '+228' },
  { name: 'Tuvalu', code: '+688' },
  { name: 'Vatican City State (Holy See)', code: '+379' },
  { name: 'Wallis and Futuna', code: '+681' },
  { name: 'Western Sahara', code: '+212' },
  { name: 'Åland Islands', code: '+358' },
].sort((a, b) => a.name.localeCompare(b.name));

const SignUp = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imageClass, setImageClass] = useState('');
  const [selectedUserType, setSelectedUserType] = useState('doctor');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedCountryCode, setSelectedCountryCode] = useState('+1'); // Default to +1 USA
  const [showPassword, setShowPassword] = useState(false); // Add state for password visibility
  const dropdownRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setImageClass('slide-out');
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setImageClass('slide-in');
      }, 500); // Half of transition duration
    }, 2000); // Change image every 2 seconds
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleDotClick = (index) => {
    if (index !== currentImageIndex) {
      setImageClass('slide-out');
      setTimeout(() => {
        setCurrentImageIndex(index);
        setImageClass('slide-in');
      }, 500); // Half of transition duration
    }
  };

  const handleUserTypeChange = (type) => {
    setSelectedUserType(type);
  };

  const handleCountrySelect = (code) => {
    setSelectedCountryCode(code);
    setIsDropdownOpen(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="signin-signup-container">
      <div className="left-panel">
        <h1>Create your account</h1>
        <p>to access smarter healthcare, secure records, and AI-powered assistance — all in one place.</p>
        <div className="image-carousel">
          <img src={images[currentImageIndex]} alt="Sign In" className={imageClass} />
          <div className="carousel-dots">
            {images.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => handleDotClick(index)}
              ></span>
            ))}
          </div>
        </div>
      </div>
      <div className="right-panel">
        <div className="form-container" style={{padding:'25px 40px 16px 40px'}}>
          <div className="form-header">
            <img src="/images/GenixLogo.png" alt="Genix Logo" className="genix-logo" />
            <div className="user-type-toggle-group">
              <div
                className={`toggle-button ${selectedUserType === 'doctor' ? 'active' : ''}`}
                onClick={() => handleUserTypeChange('doctor')}
              >
                Doctor
              </div>
              <div
                className={`toggle-button ${selectedUserType === 'patient' ? 'active' : ''}`}
                onClick={() => handleUserTypeChange('patient')}
              >
                Patient
              </div>
              <div
                className={`toggle-button ${selectedUserType === 'admin' ? 'active' : ''}`}
                onClick={() => handleUserTypeChange('admin')}
              >
                Admin
              </div>
            </div>
          </div>
          <h2>Getting Started</h2>
          <p>Already have an account? <NavLink to="/login">Sign in</NavLink></p>
          <form>
            <div className="input-row">
              <input type="text" placeholder="First Name *" />
              <input type="text" placeholder="Last Name *" />
            </div>
            <input type="email" placeholder="E-mail *" />
            <div className="password-field">
              <input 
                type={showPassword ? "text" : "password"} 
                placeholder="Password *" 
              />
              <span 
                className="password-toggle" 
                onClick={togglePasswordVisibility}
              >
                {showPassword ? "👁️‍🗨️" : "👁️"}
              </span>
            </div>
            <div className="input-row">
              <div className={`custom-country-dropdown ${isDropdownOpen ? 'dropdown-open' : ''}`} ref={dropdownRef}>
                <div className="selected-country-code" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                  {selectedCountryCode} <span className="dropdown-arrow">▼</span>
                </div>
                {isDropdownOpen && (
                  <ul className="country-list">
                    {countries.map((country) => (
                      <li key={country.code} onClick={() => handleCountrySelect(country.code)}>
                        {country.name} ({country.code})
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <input type="tel" placeholder="Phone no. *" />
            </div>
            <button type="submit">Sign up</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignUp; 